(function() {
    $('.btn-expand-all').click(function (event) {
        event.preventDefault()

        toggleExpandButton($(this), !isExpandButtonsAllClosed());
    
        $('.details-control, .btn-expand-row').trigger('click', [!isExpandButtonsAllClosed()]);
    })
})()
